import { HashRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import "./index.css";
import i18n from "./i18n";
import { AppRoutes } from "./router";

declare const __BASE_PATH__: string;

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <HashRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </HashRouter>
    </I18nextProvider>
  );
}

export default App;
